import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ProjectCarousel() {
  const projectImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/eByoe6W38dQT7T9ABeug5Z/imagen_1.webp',
    alt: 'Proyecto de resina 1'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/sFFZiH3d3BH9BD9hM8GSXR/imagen_2.webp',
    alt: 'Proyecto de resina 2'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/gAfJG97nyHgSH1YwDvfcfr/imagen_3.webp',
    alt: 'Proyecto de resina 3'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jMRiS11wyWcfzrjKfg2xYK/imagen_4.webp',
    alt: 'Proyecto de resina 4'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/xjTJybJa8s7s2HdA8myHL5/imagen_5.webp',
    alt: 'Proyecto de resina 5'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/eznZye44pibJeVN2k43Sxe/imagen_6.webp',
    alt: 'Proyecto de resina 6'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/td8oeK3hQd76DWcQhKZLiz/imagen_7.webp',
    alt: 'Proyecto de resina 7'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/pM3XNshNJksF11Kx37sNZJ/imagen_8.webp',
    alt: 'Proyecto de resina 8'
  }];
  // Duplicate the array to create a seamless infinite loop
  const duplicatedImages = [...projectImages, ...projectImages];
  return <section className="py-10 px-4 relative z-10 bg-[#fdf8f3] overflow-hidden border-y border-gray-200" data-id="element-276" data-mp="1vw4roxrb1t8b">
      <style data-id="element-277" data-mp="187v17ij5chau">
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-scroll {
            animation: scroll 50s linear infinite;
          }
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}
      </style>

      <div className="max-w-3xl mx-auto" data-id="element-278" data-mp="2thsf4t5s917p">
        <div className="text-center mb-12" data-id="element-279" data-mp="2tky6kf1vwf6l">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-gray-200 text-sm font-bold mb-6 tracking-wide text-[#d97706]" data-id="element-280" data-mp="2oiz02waul25f">
            <span className="relative flex h-2 w-2" data-id="element-281" data-mp="3ajptb8ll47rv">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#d97706] opacity-75" data-id="element-282" data-mp="2cxifr97az53d"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-[#d97706]" data-id="element-283" data-mp="2hwlmqz6ufldz"></span>
            </span>
            ✨ PROYECTOS REALES
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4 tracking-tight leading-[1.1] uppercase" data-id="element-284" data-mp="2rm56s86allaf">
            ARTE EN RESINA
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-400 max-w-2xl mx-auto font-medium" data-id="element-285" data-mp="c9e4httkp3xe">
            Mirá lo que podés crear con las técnicas del ebook
          </motion.p>
        </div>

        {/* Marquee Container */}
        <div className="relative w-full overflow-hidden py-8" data-id="element-286" data-mp="3fpl8y2jtb578">
          {/* Left and Right fade gradients for smooth edges */}
          <div className="absolute left-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-r from-[#fdf8f3] to-transparent z-10 pointer-events-none" data-id="element-287" data-mp="3ap6yyeynhl6k" />
          <div className="absolute right-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-l from-[#fdf8f3] to-transparent z-10 pointer-events-none" data-id="element-288" data-mp="35thvw1nf9m5i" />

          {/* Scrolling Track */}
          <div className="flex w-max animate-scroll gap-6 px-4" data-id="element-289" data-mp="1embyoq8bni3t">
            {duplicatedImages.map((image, index) => <div key={index} className="w-80 md:w-96 h-64 md:h-72 shrink-0 cursor-pointer group" data-id="element-290" data-mp="zwd1oqsi6cpx" data-mpi={index}>
                <div className="relative w-full h-full overflow-hidden rounded-2xl border border-gray-200" data-id="element-291" data-mp="qwhm89rwzvk3">
                  <img src={image.src} alt={image.alt} width={384} height={288} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-292" data-mp="vxdqiog6hjq1" />
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}